export type PottingCartonSendFlow = "first_pass" | "internal_first_pass" | "rework" | "internal_rework";

/** Carton numbers are per flow — never key maps or React lists by carton number alone. */
export function pottingCartonMapKey(
  flow: PottingCartonSendFlow | undefined,
  cartonNumber: number,
): string {
  return `${flow ?? "first_pass"}:${cartonNumber}`;
}
